import routes from "../../../../../../Routes/routes";
import {CloseIcon, WarningChip} from "../../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const STEP_MODEL = {
    COMPLETE: {
        TOTAL: 4,
        NAME: 'COMPLETE'
    },
}
